import React from 'react';
import { Link } from 'react-router-dom';

function Project({ projects, limit }) {
  const displayedProjects = limit ? projects.slice(0, limit) : projects;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
      {displayedProjects.map((project) => (
        <div key={project.id} className="bg-bg-light rounded-lg shadow-md border border-border-subtle overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col">
          <img src={project.image} alt={project.name} className="w-full h-48 object-cover" />
          <div className="p-6 flex flex-col flex-grow">
            <h2 className="text-2xl font-semibold text-text-white mb-2">{project.name}</h2>
            <p className="text-text-gray mb-4 flex-grow">{project.excerpt}</p>
            <div className="flex flex-wrap gap-2 mt-auto">
              {Array.isArray(project.technologies) && project.technologies.map((tech, index) => (
                <span key={index} className="bg-accent-red/20 text-accent-red text-sm px-3 py-1 rounded-full">
                  {tech}
                </span>
              ))}
            </div>
            <div className="flex justify-center mt-4">
              <Link
                to={`/projects/${project.slug}`}
                className="text-text-white bg-accent-red px-4 py-2 rounded-full hover:bg-red-700 transition-colors duration-300 font-bold text-sm"
              >
                View Project
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Project;